import { render, staticRenderFns } from "./DirectionIcon.vue?vue&type=template&id=1836a6e0"
import script from "./DirectionIcon.vue?vue&type=script&lang=js"
export * from "./DirectionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports